export const hotlineBlocklistFields = {
    id: "id",
    phoneNumber: "phone_number", 
    notes: "notes",
    appliesToTx: "applies_to_tx",
    appliesToTn: "applies_to_tn",
    createdAt: "created_at",
    updatedAt: "updated_at"
};

export const HOTLINE_STATE_CHOICES = [
    { id: 'TX', name: 'Texas' },
    { id: 'TN', name: 'Tennessee' },
    { id: 'BOTH', name: 'Both TX and TN' }
];

export const HOTLINE_STATE_DISPLAY = {
    TX: 'Texas',
    TN: 'Tennessee',
    BOTH: 'Both TX and TN'
}; 